export const getHttpRequest = async () => {
    try {
        const response = await fetch('https://pokeapi.co/api/v2/pokemon/ditto');
        const data = await response.json();
        console.info('data', data);

        return data;
    } catch (e) {
        console.error('error', e);
    } 
}